export default "__VITE_ASSET__BLyzoDoT__"